import { render, staticRenderFns } from "./MapFieldConfigComponent.vue?vue&type=template&id=8953e20a&scoped=true"
import script from "./MapFieldConfigComponent.vue?vue&type=script&lang=js"
export * from "./MapFieldConfigComponent.vue?vue&type=script&lang=js"
import style0 from "./MapFieldConfigComponent.vue?vue&type=style&index=0&id=8953e20a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8953e20a",
  null
  
)

export default component.exports